var name = "Scarlet 300_3B5Pv1";
var uuid = "51aabc26-3e6e-44f3-8613-8675704b328d";
var pos = [
	0,
	0,
	0
];
var rot = [
	0,
	0,
	0
];
var size = [
	14.375,
	3.0475,
	9.775
];
var anchor = [
	0.5,
	0,
	0.7953964323972159
];
var color = "#ffc845";
var alpha = 1;
var rg = true;
var type = "Apartment";
var children = [
	{
		name: "balcony",
		uuid: "16297e36-14c7-47ad-8b2f-2a546bfd2f59",
		pos: [
			-6.9125,
			0.145,
			-7.775
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			9.925,
			0.16,
			1.5
		],
		anchor: [
			0,
			0,
			0
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Balcony",
		children: [
			{
				name: "floor",
				uuid: "c6ebbf2a-ce99-4b12-bea0-8eeb258aef7f",
				pos: [
					4.9625,
					0.08,
					0.75
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					9.925,
					0.16,
					1.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "BFA|01|",
				type: "Floor"
			}
		]
	},
	{
		name: "Bedroom Single",
		uuid: "a619f065-a20f-47fb-92f8-24e7db05848e",
		pos: [
			1.95,
			0.305,
			-4.135
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2.4,
			2.4384,
			3.405
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#69d2e7",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomSingle"
		}
	},
	{
		name: "Utility",
		uuid: "b673f57b-3a3e-4f4d-932b-92c12993d0c2",
		pos: [
			-2.35,
			0.305,
			-0.5375
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			0.8,
			2.4384,
			1.6
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#c44d58",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Utility"
		}
	},
	{
		name: "Hallway",
		uuid: "a93baa6f-d6fb-4741-9a6e-a1588f98a7af",
		pos: [
			-0.0525,
			0.305,
			-1.2375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			9.805,
			2.4384,
			2.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#4ecdc4",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Hallway",
			polygon: [
				[
					0.7516,
					0.305,
					-2.3375
				],
				[
					-4.955,
					0.305,
					-2.3375
				],
				[
					-4.955,
					0.305,
					-1.0325
				],
				[
					-3.45,
					0.305,
					-1.0325
				],
				[
					-3.45,
					0.305,
					-1.2375
				],
				[
					-3.15,
					0.305,
					-1.2375
				],
				[
					-3.15,
					0.305,
					-1.0325
				],
				[
					0.45,
					0.305,
					-1.0325
				],
				[
					0.45,
					0.305,
					-1.2375
				],
				[
					0.75,
					0.305,
					-1.2375
				],
				[
					0.75,
					0.305,
					-1.0325
				],
				[
					1.682,
					0.305,
					-1.0325
				],
				[
					1.682,
					0.305,
					-0.1375
				],
				[
					3.15,
					0.305,
					-0.1375
				],
				[
					3.15,
					0.305,
					-1.2375
				],
				[
					3.45,
					0.305,
					-1.2375
				],
				[
					3.45,
					0.305,
					-1.0325
				],
				[
					4.85,
					0.305,
					-1.0325
				],
				[
					4.85,
					0.305,
					-2.3375
				],
				[
					0.7516,
					0.305,
					-2.3375
				]
			]
		}
	},
	{
		name: "Bedroom Double",
		uuid: "946b1d02-362d-4d67-86d5-142d5164c865",
		pos: [
			-1.35,
			0.305,
			-4.135
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			3.405
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "Storage",
		uuid: "425542f3-fc04-4028-9a34-5149c1b2183c",
		pos: [
			1.1685,
			0.305,
			-0.5375
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			0.8,
			2.4384,
			0.837
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "Storage",
		uuid: "303f4866-70f0-4f3f-a0ba-085da6c34c55",
		pos: [
			-0.5025,
			0.305,
			-0.5375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.905,
			2.4384,
			0.8
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "Bedroom Double",
		uuid: "aa639e4a-0dd8-421c-8098-138b0020af88",
		pos: [
			-5.25,
			0.305,
			-4.135
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			3.405
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "M4(2) Bathroom",
		uuid: "5154311b-e41c-40b3-ba92-a0287d36cb14",
		pos: [
			-6.05,
			0.305,
			-1.2375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2,
			2.4384,
			2.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fe4365",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Bathroom"
		}
	},
	{
		name: "Kitchen / Living / Dining",
		uuid: "ca379cb9-a6a9-4dc9-82ba-b922f46847bd",
		pos: [
			5.25,
			0.305,
			-2.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.6,
			2.4384,
			9.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#00a0b0",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "KitchenLivingDining",
			polygon: [
				[
					7.05,
					0.305,
					-7.3375
				],
				[
					3.45,
					0.305,
					-7.3375
				],
				[
					3.45,
					0.305,
					-5.9063
				],
				[
					3.45,
					0.305,
					-2.4325
				],
				[
					4.945,
					0.305,
					-2.4325
				],
				[
					4.945,
					0.305,
					-0.985
				],
				[
					4.945,
					0.305,
					1.8625
				],
				[
					7.05,
					0.305,
					1.8625
				],
				[
					7.05,
					0.305,
					-7.3375
				]
			]
		}
	},
	{
		name: "Storage",
		uuid: "c56105d4-4595-4b37-9526-93c99b52d87f",
		pos: [
			-4.2025,
			0.305,
			-0.5375
		],
		rot: [
			0,
			90,
			0
		],
		size: [
			0.8,
			2.4384,
			1.505
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "WC",
		uuid: "8c2c30c1-f69e-40a9-bfbd-359e4c2f65ea",
		pos: [
			4.15,
			0.305,
			0.4625
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.4,
			2.4384,
			2.8
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fc9d9a",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "WC"
		}
	},
	{
		name: "module",
		uuid: "2ae670c2-68b9-464c-8080-bf0e3c0300bb",
		pos: [
			1.95,
			1.5238,
			-2.9875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2.675,
			3.0475,
			5.975
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#ffc845",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "0e5c4c01-0ea7-4006-aada-87f4e3660215",
				pos: [
					0,
					0.0687,
					0.6025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.4,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "03e5c078-7392-4955-9232-e8a69c7bf956",
						pos: [
							0.6,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "230c6862-409f-4236-8448-696937af8a6a",
				pos: [
					0,
					0.0712,
					-2.9187
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.4,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "057e4e14-c10d-43c4-9a8a-46446b572f77",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.15,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0002",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "e7161da8-64a0-4f9e-ba7a-3152520cc3c4",
				pos: [
					-1.2687,
					0.0712,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.8375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "8914c168-d136-41fc-96d7-0a338ed8284d",
						pos: [
							1.3188,
							-0.2825,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "7cdeb01f-cd82-4d2e-a665-f4df7009e9eb",
				pos: [
					-0.0687,
					0.0712,
					2.9188
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					2.5375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "bab59569-afef-4d2a-9d7f-f261a8a0bf52",
						pos: [
							-0.5638,
							-0.2275,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.01,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|01|UK-DIS0001",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: true
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "5d421f0c-8888-44fc-831e-5d31de1b67e9",
				pos: [
					1.2687,
					0.0712,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.975,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "ef32eda9-4fc4-4d20-a9da-7e5ac1225f52",
						pos: [
							-1.25,
							-0.2825,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "ad8f99d2-966f-4b2c-8774-2ce8c7f2a675",
				pos: [
					-0.3155,
					0.0687,
					2.4025
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					0.895,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "cad54417-a116-4856-a9d9-750181fece55",
						pos: [
							-0.4,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.095,
							2.09,
							0.81
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "0168a6b7-e8d3-47b6-bfe4-b368bd375315",
				pos: [
					-0.7815,
					0.0687,
					2.0025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					0.837,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "12f3c643-824f-4d19-a8e4-0f28e48b00a9",
						pos: [
							-0.021,
							-0.225,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.81,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0003",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "cbcf164a-70d5-4f5a-bb77-15b11cf564d4",
				pos: [
					0,
					-1.2613,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.065,
					2.4
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "9f126f4c-5944-471e-ba71-f5ce6f76b870",
				pos: [
					0,
					-1.2238,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.01,
					2.4
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "3502e1c1-2ed1-48a4-85ff-2bcba2e210dd",
				pos: [
					0,
					-1.4088,
					-2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.64,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "58ef947b-a721-48e0-97d8-6e5d65358765",
				pos: [
					0,
					-1.4088,
					2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.64,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "886cbb83-4b90-41cf-a2a0-ae2a70c737af",
				pos: [
					0,
					-1.3733,
					-1.3512
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "cdaf45b0-88cc-4feb-8340-db7b8fe8518d",
				pos: [
					0,
					-1.3733,
					-1.5987
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "b317e5e1-1f66-44a4-9f5b-a7f50642ee34",
				pos: [
					0,
					-1.3733,
					2.7988
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "0c3b2405-9008-4563-b4fa-7810fbf81f7e",
				pos: [
					0,
					-1.3733,
					2.5513
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "b48b8982-67f4-4dda-a417-259c2d339c9a",
				pos: [
					0,
					-1.3608,
					-2.8425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.24,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "02e8d486-577b-4289-ba0d-bc84b0c612f0",
				pos: [
					0,
					-1.3608,
					0.0562
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "a4ae7f23-e8b8-4df3-b1d5-328485c69e1f",
				pos: [
					0,
					-1.3608,
					-0.0037
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "69bda928-ddc5-4578-a80b-4def32d446a8",
				pos: [
					0,
					-1.3608,
					1.3563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "69527cec-858f-444d-853b-7f538e9ed616",
				pos: [
					0,
					-1.3608,
					1.2963
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "fad7c2d2-a045-4857-8578-5d845e655304",
				pos: [
					-1.275,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "6f32e6b8-a100-48ff-959a-7e27413f25ec",
				pos: [
					1.275,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "9b467c91-e529-4b13-a715-19755e013735",
				pos: [
					-1.275,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "bbb5a676-2dc5-42f1-9f68-8c4b1123f663",
				pos: [
					-1.275,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "55143265-cfa8-4352-a092-ebfd093310cd",
				pos: [
					1.275,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "c9819297-aceb-447c-9636-5a0d29952c00",
				pos: [
					1.275,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "ceiling",
				uuid: "6e897584-acc2-4094-8d41-655fb63fc006",
				pos: [
					0,
					1.4463,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.155,
					2.4
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "bc0341c2-0560-4f30-aefa-0fe9727aeab1",
		pos: [
			-1.35,
			1.5238,
			-2.9875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.0475,
			5.975
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#ffc845",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "eb696745-3c76-4b73-8689-97ee45267c68",
				pos: [
					0,
					0.0712,
					-2.9187
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "d6316a5e-e235-4427-9940-52e8db90e2a8",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.75,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0003",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "1a845797-c268-46d5-8f87-85dbed09fecd",
				pos: [
					-1.8687,
					0.0712,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.8375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "ce83e803-e579-4ef6-b708-f6a68f819333",
						pos: [
							1.3188,
							-0.2825,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "810ee6c4-b59e-41f6-baa4-b5aa68412472",
				pos: [
					-0.0687,
					0.0712,
					2.9188
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "a4a520c6-7372-4b2c-8536-7b6c5813de62",
				pos: [
					1.8687,
					0.0712,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.975,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "7f3a6af7-50f4-4b52-9474-53ccfe25ea59",
						pos: [
							-1.25,
							-0.2825,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "7caba2b8-7a65-4b43-a685-6f6c1e3d21e3",
				pos: [
					0,
					0.0687,
					0.6025
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "7dac8db5-d8b4-4402-b049-0db3eb170f29",
						pos: [
							-1.2,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "5c9c35a9-c3ad-41da-a022-f80d54442013",
				pos: [
					0,
					0.0687,
					2.0025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "0889af3a-ee64-4178-aef2-5d42546c08e8",
						pos: [
							-1,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					},
					{
						name: "door",
						uuid: "823c4be6-dc6b-426a-a189-75edd2b763fa",
						pos: [
							0.875,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "94159385-9d14-46b8-8413-c5c0682c7dbc",
				pos: [
					-0.1525,
					0.0687,
					2.45
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					0.8,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "97fc2aac-aaa1-45c7-bbdd-1d20bc0c985c",
				pos: [
					0,
					-1.2613,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "06f92c04-37c7-4306-9ea3-88501104bcb0",
				pos: [
					0,
					-1.2238,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "c736a096-43e0-44f7-ac10-e9d3a6d05c21",
				pos: [
					0,
					-1.4088,
					-2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "71a3d1f0-2967-4ec7-8b33-d3ad63927dd3",
				pos: [
					0,
					-1.4088,
					2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "3d0864d0-49a3-44e7-bcf4-6d07745ca6db",
				pos: [
					0,
					-1.3733,
					-1.3512
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "c1e51cdd-689c-4533-9641-d319cf4ff79a",
				pos: [
					0,
					-1.3733,
					-1.5987
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "43f82df3-2386-4190-8949-7e177cd887f2",
				pos: [
					0,
					-1.3733,
					2.7988
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "38ea64fa-50f5-428f-b4a6-45ca614cf8a2",
				pos: [
					0,
					-1.3733,
					2.5513
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "53ee5b07-3e4b-4e77-8920-8e6bf6899954",
				pos: [
					0,
					-1.3608,
					-2.8425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.44,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d99cf8e2-02cf-45c0-8846-d48b2c688065",
				pos: [
					0,
					-1.3608,
					0.0562
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "f14ec967-7096-4261-909a-b4f771f5e09d",
				pos: [
					0,
					-1.3608,
					-0.0037
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8ba16e85-3fe1-4ec6-a0f4-abaf1830a56d",
				pos: [
					0,
					-1.3608,
					1.3563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8aee64b6-ef48-4a22-bafb-be0bbd52d939",
				pos: [
					0,
					-1.3608,
					1.2963
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "1e1c4f91-f1be-40a2-ac1e-6aad8e44bc4c",
				pos: [
					-1.875,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "e55c53f7-62fc-4542-af29-ee0ae630e5bd",
				pos: [
					1.875,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "d7e19801-6ee3-4b37-a70e-cc7cb2815985",
				pos: [
					-1.875,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "4a41f696-519b-45ed-8954-8124ccd9f49d",
				pos: [
					-1.875,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "914c69f0-652d-43f4-b450-cce1d7802f0f",
				pos: [
					1.875,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "09a0f355-5f7e-4e4e-a036-7306755af272",
				pos: [
					1.875,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "ceiling",
				uuid: "ac6d85e5-3bec-4ef2-a3cc-1269cf8aeab0",
				pos: [
					0,
					1.4463,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "a8288f59-7cad-455d-be73-ec664f3a3d41",
		pos: [
			-5.25,
			1.5238,
			-2.9875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.0475,
			5.975
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#ffc845",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "323fa4ac-7445-4669-8744-89ca372597dc",
				pos: [
					0,
					0.0712,
					-2.9187
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "a7fea87c-067d-49e2-9f9c-5468b28ca1a2",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.75,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0003",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "f38a52fc-b3ec-4c57-a061-e876354f1cb6",
				pos: [
					1.8687,
					0.0712,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.8375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "9f786e11-216f-413a-b0ab-90d7ee23b01c",
						pos: [
							1.3188,
							-0.2825,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "92202346-c87e-4a10-92b9-17203a72a4bc",
				pos: [
					0.0688,
					0.0712,
					2.9188
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "d888ada6-46d0-4764-8747-e00044abec14",
				pos: [
					-1.8687,
					0.0712,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.975,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "ae4a9228-7969-4261-87df-919a054f98b1",
				pos: [
					0,
					0.0687,
					0.6025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "fd54d846-311c-4a64-a96b-3e51115a371b",
						pos: [
							1.2,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "d3755010-8428-448e-ba39-689c2c396c72",
				pos: [
					0.2475,
					0.0687,
					1.75
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					2.2,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "59938f89-8373-421c-bca5-d77224d11026",
						pos: [
							0.5,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "78973a98-6ac8-41a9-bdc7-2840f6707665",
				pos: [
					1.0475,
					0.0687,
					2.0025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					1.505,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "b66ffe7b-ef97-4784-9805-fd5764e24271",
						pos: [
							0.1075,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "8a52f6c9-666e-4b34-ac85-6ecbacf04071",
				pos: [
					0,
					-1.2613,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "bfbe9de4-4440-4a79-9a8c-0d2b7dfadbb8",
				pos: [
					0,
					-1.2238,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "05c7dcc5-27d5-403f-8cb2-6e84eb4a631a",
				pos: [
					0,
					-1.4088,
					-2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "88b67e40-0af9-4921-a4a8-20b396261c13",
				pos: [
					0,
					-1.4088,
					2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "a8d367d5-1a5d-4150-a63f-cb0e4c32d37a",
				pos: [
					0,
					-1.3733,
					-1.3512
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "997600fd-1ab1-4507-9f5a-2d08c4d067a2",
				pos: [
					0,
					-1.3733,
					-1.5987
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "c82ed434-ab0d-45b8-8bc1-9d1f457b4185",
				pos: [
					0,
					-1.3733,
					2.7988
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "7b42ddff-6472-4758-8a8e-77169966663f",
				pos: [
					0,
					-1.3733,
					2.5513
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "bdd95873-9389-47cc-9798-c0597985f4c9",
				pos: [
					0,
					-1.3608,
					-2.8425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.44,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d911a436-88b3-461d-9ae1-6b531d19a19d",
				pos: [
					0,
					-1.3608,
					0.0562
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "da10fff0-bf39-422d-8584-e2c4cc4aa355",
				pos: [
					0,
					-1.3608,
					-0.0037
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "361a3eed-f82e-450d-9583-6fb804eecffe",
				pos: [
					0,
					-1.3608,
					1.3563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "77e9377d-1a7c-47fa-a5e1-e0a73db229f3",
				pos: [
					0,
					-1.3608,
					1.2963
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "0ecbf638-1e4f-4355-99c1-485be5d05058",
				pos: [
					-1.875,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9a19543f-5dd0-4a5e-b2dc-e80bfaee1f6c",
				pos: [
					1.875,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "ccca89af-2232-4233-abe4-dc974ae81065",
				pos: [
					-1.875,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "8d548d27-ebb8-4ac4-ada5-ec1d9882e7cd",
				pos: [
					-1.875,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "64e04b21-0504-4a82-8b20-0896bdd3f9e2",
				pos: [
					1.875,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "13ce4fc4-46e5-4c56-9f3a-7fd9f551d508",
				pos: [
					1.875,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "ceiling",
				uuid: "666a61b4-0da9-49cc-b4f0-c46df43eb8d6",
				pos: [
					0,
					1.4463,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "45b0b81d-9c55-498d-a6d6-73de0f9c57af",
		pos: [
			5.25,
			1.5225,
			-2.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			9.475
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#ffc845",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "6acac495-e886-44b7-9ed2-1be97a6d1559",
				pos: [
					0,
					0.0725,
					-4.6687
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "a0b87460-5a57-4393-b3dd-b279333801ce",
						pos: [
							0,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.76,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|12|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "767ad032-596b-4b61-aeab-0cfec8549aad",
				pos: [
					1.8688,
					0.0725,
					-0.0687
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					9.3375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "af832e56-a35d-4943-a153-0616daaec7b4",
						pos: [
							-0.7063,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.85,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|13|",
						type: "Window"
					},
					{
						name: "window",
						uuid: "f414d7b9-40f1-4161-9271-8726b8571c35",
						pos: [
							3.4937,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.15,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|14|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "2edaff36-0abb-4be0-bec3-4fc34074812d",
				pos: [
					0.0687,
					0.0725,
					4.6687
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "8b8b60c0-5953-4052-964e-c5ac0e43276f",
				pos: [
					-1.8688,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.475,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "95482af4-8096-427a-9f53-44a6762bbbd5",
						pos: [
							-1,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "1d8f69b1-83a4-4e60-aff2-6ed4a957d227",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.2,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "90e1d0d3-410e-4c3b-b2f1-43b0955c31bb",
				pos: [
					-1.0525,
					0.07,
					0.3525
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					1.495,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "9edcc774-017e-4f4e-a8c5-266cf5b6a6b9",
						pos: [
							-0.0475,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "5b368d94-3164-415f-ac9c-ce142df174c8",
				pos: [
					-0.3525,
					0.07,
					2.5
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					4.2,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "4724efc4-bd28-4e0d-9666-9f6364512b61",
				pos: [
					-1.1,
					0.07,
					1.7525
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					1.4,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "90886547-7964-421a-a67c-c1b25892ec69",
						pos: [
							0,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "b4103495-e8e6-4513-ae44-368824fe4b2e",
				pos: [
					0,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.2,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "648c662f-c65b-491a-82e9-98ff5b22d2d7",
				pos: [
					0,
					-1.4075,
					-4.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "0081944c-7deb-4462-bd40-3d2115924130",
				pos: [
					0,
					-1.4075,
					4.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "f4eddb8d-258a-4870-8ba2-03e9d7c8e107",
				pos: [
					0,
					-1.372,
					4.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "5bba1b7d-ae5a-42f2-910c-0cb8c6183fce",
				pos: [
					0,
					-1.372,
					4.3012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "bbe5c234-3ca1-4c4b-bec4-290b1dea35cc",
				pos: [
					0,
					-1.3595,
					-0.255
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "c6ee1753-6105-4a62-9bc5-3bc68a7def65",
				pos: [
					0,
					-1.3595,
					-0.315
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "b9a3981c-daed-4b38-a3c4-6230da19c1bf",
				pos: [
					0,
					-1.3595,
					1.045
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "b06d9bc1-c555-403c-8053-475c3dda3d22",
				pos: [
					0,
					-1.3595,
					0.985
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "fc4d8218-be7a-460e-999e-a8ae0934565b",
				pos: [
					-1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "4a9927e9-d266-4807-b366-b422b67654f6",
				pos: [
					1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "0b306d3f-7c5f-411c-960a-2afcb256f2ce",
				pos: [
					-1.875,
					0.0812,
					4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "669ed3ea-10a0-4bc0-862b-eb171e0f70fb",
				pos: [
					1.875,
					0.0812,
					4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "ce97394f-0e6c-4d66-92ba-53979ac1f9a6",
				pos: [
					0,
					-1.372,
					-4.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "95ec5453-bc54-471d-a65f-2bdc1122eb05",
				pos: [
					0,
					-1.372,
					-4.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "ff034c0a-fc6b-4ec4-aedb-df1003d79a71",
				pos: [
					-1.875,
					0.0812,
					-4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "f310e2b6-a45c-4580-8354-9496ebd61a0c",
				pos: [
					1.875,
					0.0812,
					-4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "d4fd43a9-3c5d-4ebd-a24a-d268ccbb3f87",
				pos: [
					0,
					-1.372,
					-1.6012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "5c42bb79-5379-4b25-89e0-cd3eae982c52",
				pos: [
					0,
					-1.372,
					-1.8488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "bf40cbbf-0711-48e5-be1c-a59bc8c647c5",
				pos: [
					-1.875,
					0.0812,
					-1.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "a8b473cd-abff-443c-8a18-3c61ca91611a",
				pos: [
					0,
					-1.372,
					2.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "198c52c8-eb7f-4e5c-8e73-5404d7c29ca2",
				pos: [
					0,
					-1.372,
					2.3012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "1bf0ab37-0e73-43e4-be0e-1fb499f11895",
				pos: [
					-1.875,
					0.0812,
					2.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "6539e95d-67b8-470e-ac4b-4f12b2abf024",
				pos: [
					1.875,
					0.0812,
					2.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "dcb52101-50dd-4c60-a5d9-55cd827874a4",
				pos: [
					0,
					-1.3595,
					3.485
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "5127d0cb-dbc1-48d4-bb5d-5e9b7a2b7e8b",
				pos: [
					0,
					-1.3595,
					3.425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "e7d4daca-790e-4171-9e84-1c715a601367",
				pos: [
					0,
					-1.3595,
					-3.195
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "01f5d971-c84b-46ed-99fd-b8264608afef",
				pos: [
					0,
					-1.3595,
					-3.135
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "36ad38ac-2c8d-430d-96f5-8f26ce561220",
				pos: [
					1.875,
					0.0812,
					-1.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "ceiling",
				uuid: "43fd9902-823e-44bd-8fb6-39d54a6928cb",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.2,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	}
];
var data = {
	level: -1,
	levelId: "",
	occupants: 5,
	bedrooms: 3,
	habitableRooms: 4,
	nia: 92.97,
	muscleID: "",
	category: "3B5P",
	closeCorridor: true,
	closeDirection: [
		1,
		0,
		0
	],
	closeLength: 3.875
};
var UK01_3B5P_V1 = {
	name: name,
	uuid: uuid,
	pos: pos,
	rot: rot,
	size: size,
	anchor: anchor,
	color: color,
	alpha: alpha,
	rg: rg,
	type: type,
	children: children,
	data: data
};

export { alpha, anchor, children, color, data, UK01_3B5P_V1 as default, name, pos, rg, rot, size, type, uuid };
//# sourceMappingURL=Scarlet-300-3B5Pv1.json.js.map
